import React from 'react';
import { FAIcon } from '../../fa-icon/component.js';
import { GenericLabel } from '../../generic-label/component.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Icon } from '../../../core/components/Icon/component.js';
import Button from '../../../core/components/Button/component.js';
import { Label } from '../../../core/components/Label/component.js';
var CardParentBox = function CardParentBox(props) {
  var additionalClasses = props.additionalClasses,
    _props$chakra = props.chakra,
    chakra = _props$chakra === void 0 ? 'on' : _props$chakra,
    _props$chevron = props.chevron,
    chevron = _props$chevron === void 0 ? true : _props$chevron,
    className = props.className,
    icon = props.icon,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 'medium' : _props$iconSize,
    label = props.label,
    _props$showChildren = props.showChildren,
    showChildren = _props$showChildren === void 0 ? false : _props$showChildren,
    toggleChildren = props.toggleChildren;
  var expanded = showChildren && chevron;
  var labelIcon = expanded ? 'angle-down' : 'angle-right';
  var iconSizes = {
    small: 'sm',
    medium: '1x',
    large: 'lg',
    extralarge: 'xl'
  };
  return chakra === 'on' ? /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Layout, {
    textAlign: "center"
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    iconName: icon,
    size: iconSizes[iconSize]
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: toggleChildren,
    variant: 'tertiary'
  }, /*#__PURE__*/React.createElement(Label, {
    label: {
      type: 'iconRight',
      options: {
        icon: {
          iconName: labelIcon,
          size: '1x'
        },
        text: label
      }
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("button", {
    className: "card-parent-label",
    onClick: toggleChildren,
    role: "button"
  }, icon && /*#__PURE__*/React.createElement(FAIcon, {
    icon: icon,
    additionalClasses: additionalClasses,
    size: iconSize
  }), /*#__PURE__*/React.createElement(GenericLabel, {
    label: label,
    icon: labelIcon,
    iconPosition: "right"
  })));
};
CardParentBox.displayName = 'CardParentBox';
export { CardParentBox };